import { createContext, useContext } from "react";

// Current tenant's profile ({slug, name, enabled_pages, arecanut_pricing_mode,
// arecanut_bag_batch}), provided by App.js once /auth/verify resolves, plus
// a `_refresh()` to re-fetch it after a page updates an operator-editable
// setting (PUT /tenant/settings) so the change applies everywhere without a
// full reload. Pages that need to branch on tenant-specific settings (e.g.
// Farmers.jsx's pricing mode) read it via useTenant() instead of
// prop-drilling through the module/nav system.
export const TenantContext = createContext(null);

export function useTenant() {
  return useContext(TenantContext);
}
